import React from 'react'
import { T } from '@transifex/react'
import { Button, Result } from 'src/antd'
import styled from 'styled-components'

const Container = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

type Props = { children: React.ReactNode }
type State = { hasError: boolean }

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  render() {
    const { hasError } = this.state
    const { children } = this.props

    if (hasError) {
      return (
        <Container>
          <Result
            status="warning"
            title={<T _str="Oops! Something went wrong" />}
            extra={
              <Button
                onClick={() => this.setState({ hasError: false })}
                type="primary"
              >
                <T _str="Try again" />
              </Button>
            }
          />
        </Container>
      )
    }

    return children
  }
}
